import { OrderDTO } from '@invenco/sales-interface/interfaces';

import { Form } from '@/components-ant/form';
import { FormModal } from '@/components-ant/form-modal';
import { Input } from '@/components-ant/input';
import { Result } from '@/shared/helpers/Result';

import { useInstructionModalComponent } from './useInstructionModalComponent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  deliveryInstructions?: string | null;
  packingInstructions?: string | null;
  updateOrder: (data: Partial<OrderDTO>) => Promise<Result>;
};

export function InstructionModal({
  isOpen,
  deliveryInstructions,
  packingInstructions,
  updateOrder,
  onClose,
}: Props) {
  const {
    models: { form, isSaving },
    operations: { submit },
  } = useInstructionModalComponent({ isOpen, onClose, updateOrder });
  return (
    <FormModal
      title="Instructions"
      open={isOpen}
      onCancel={onClose}
      isSaving={isSaving}
      onSave={() => form.submit()}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(data) => void submit(data)}
        initialValues={{ deliveryInstructions, packingInstructions }}
      >
        <Form.Item name="deliveryInstructions" label="Delivery Instructions">
          <Input.TextArea autoFocus rows={4} aria-label="DeliveryInstructions" />
        </Form.Item>
        <Form.Item name="packingInstructions" label="Packing Instructions">
          <Input.TextArea autoFocus rows={4} aria-label="PackingInstructions" />
        </Form.Item>
      </Form>
    </FormModal>
  );
}
